<template>
    <div>
        <b-navbar id="navbar" type="dark">
            <router-link to="/">
                <b-navbar-brand style="width: 235px">
                    <img src="@/assets/logo_dark.png" height="38">
                </b-navbar-brand>
            </router-link>

            <b-nav-form>
                <SearchBox/>
            </b-nav-form>

            <b-navbar-nav class="ml-auto">
                <b-nav-item-dropdown right>

                    <!-- Using 'button-content' slot -->
                    <template v-slot:button-content>
                        <span class="mr-2">{{user.name}}</span>
                        <b-img :src="userAvatar" height="32" rounded="circle" />
                    </template>

                    <b-dropdown-item @click="logout">Deconectare</b-dropdown-item>
                </b-nav-item-dropdown>
            </b-navbar-nav>
        </b-navbar>
    </div>
</template>

<script>
    import SearchBox from "@/components/search/SearchBox";
    import {mapState} from "vuex";
    import gravatar from 'gravatar';
    import Cookies from 'js-cookie';

    export default {
        name: "Navbar",
        components: {SearchBox},
        computed: {
            ...mapState(['user']),
            userAvatar() {
                return gravatar.url(this.user.email, {d: 'mp'});
            }
        },
        methods: {
            async logout(evt) {
                evt.preventDefault();

                const cookieDomain = process.env.VUE_APP_B2B_COOKIE_DOMAIN;

                Cookies.remove('b2b_bearer', { path: '', domain: cookieDomain });
                this.$router.go(0);
            }
        }
    }
</script>

<style scoped>
    #navbar {
        background-color: #024A8C;
    }

</style>